import React from 'react';

import LocalizedStrings from 'react-localization';

class Localization extends React.Component {
  static strings = new LocalizedStrings({
    en:{
      ACCEPT: "Accept",
      ACCOUNT_SETTINGS: "Account Settings",
      ADD: "Add",
      ADD_CONTENT: "Add Content",
      ADD_MIND_MAP_FILL_IN_BOX: "ADD_MIND_MAP_FILL_IN_BOX",
      ADD_MIND_MAP_LABLE_BOX: "ADD_MIND_MAP_LABLE_BOX",
      ADMIN_TASK: "Admin Task",
      ALL_SCHOOLS: "All Schools",
      ALL_USERS: "All Users",
      ALWAYS: "Always",
      ANSWER_SIZE: "Answer Size",
      ASPECT_RATIO: "Aspect Ratio",
      ATTACHMENT:"Attachment",
      AUTHOR: "Author",
      AUTOPLAY_SOUND: "Autoplay sound",
      BACK: "Back",
      CANCEL: "Cancel",
      CATEGORY: "Category",
      CATEGORY_CREATION: "CATEGORY_CREATION",
      CATEGORY_EXPERIENCE: "CATEGORY_EXPERIENCE",
      CATEGORY_EXPERIMENT: "CATEGORY_EXPERIMENT",
      CATEGORY_EXPLORATION: "CATEGORY_EXPLORATION",
      CATEGORY_NONE: "CATEGORY_NONE",
      CATEGORY_KNOWLEDGE: "CATEGORY_KNOWLEDGE",
      CHANGE: "Change",
      CHANGE_PASSWORD: "Change Password",
      CHOICE: "CHOICE",
      CLEAR: "Clear",
      CLEAN_UP_ALL_VITALS: "Clean up all VITALS",
      CLEAN_UP_HIDDEN_VITALS: "Clean up hidden VITALS",
      CLEAN_UP_UNUSED_FILES: "Clean up unused files",
      CLOSE: "Close",
      COLOR: "Color",
      COLUMN: "Column",
      COMPARE_ANSWERS: "Compare Answers",
      CONFIRM_PUBLISH_MESSAGE: "Confirm To publish?",
      CONTENT: "Content",
      CONTENT_NAME: "Content Name",
      CONTENT_PHOTO_FILE_INSTRUCTION: "CONTENT_PHOTO_FILE_INSTRUCTION",
      CONTENT_TYPE: "Content Type",
      CONTINUE_EDITING: "Continue Editing",
      CORRECT: "Correct",
      CORRECT_ANSWER: "Correct Answer",
      COVER_IMAGE: "Cover Image",
      CREATE: "Create",
      CREATE_FAILED: "Create Failed",
      CREATE_SCHOOL: "Create School",
      CREATE_USER: "Create User",
      CREATED: "Created",
      DARK_MODE: "Dark Mode",
      DATE_INVALID_REMINDER: "Date is invalid",
      DECLINE: "Decline",
      DEFAULT: "Default",
      DELETE: "Delete",
      DELETE_CONTENT: "Delete Content",
      DELETE_FAILED: "Delete Failed",
      DELETE_FILE: "Delete File",
      DELETE_HOTSPOT: "Delete Hotspot",
      DELETE_LOCALE: "Delete Locale",
      DELETE_MIND_MAP_BOX: "DELETE_MIND_MAP_BOX",
      DELETE_MIND_MAP_LINK: "DELETE_MIND_MAP_LINK",
      DELETE_REMINDER: "Are you sure to delete it? This action is irreversible.",
      DELETE_STAGE: "Delete Stage",
      DELETE_VITALS: "Delete VITALS",
      DELETED: "Deleted",
      DEPLOYMENT: "Deployment",
      DESCRIPTION: "Description",
      DESCRIPTION_AUDIO: "DESCRIPTION_AUDIO",
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER: "DESCRIPTION_FILL_IN_THE_BLANK_AFTER",
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: "DESCRIPTION_FILL_IN_THE_BLANK_BEFORE",
      DESCRIPTION_IMAGE: "DESCRIPTION_IMAGE",
      DESCRIPTION_QUESTION: "DESCRIPTION_QUESTION",
      DESCRIPTION_TAKE_PHOTO: "DESCRIPTION_TAKE_PHOTO",
      DESCRIPTION_TAKE_RECORD: "DESCRIPTION_TAKE_RECORD",
      DESCRIPTION_TEXT: "DESCRIPTION_TEXT",
      DESCRIPTION_VIDEO: "DESCRIPTION_VIDEO",
      DESTINATION: "Destination",
      DETAILS: "Details",
      DIFFICULTY: "Difficulty",
      DISCARD: "Discard",
      DISCARD_CHANGES: "Discard Changes",
      DISPLAY_NAME: "Display Name",
      DISPLAY_NAME_BLANK_REMINDER: "Display name cannot be blank",
      DONE: "Done",
      DONE_EDITING: "Done Editing",
      DURATION: "Duration",
      EDIT: "Edit",
      EDIT_CONTENT: "Edit Content",
      EDIT_ELEMENT: "Edit Element",
      EDIT_STAGE: "Edit Stage",
      EDIT_STAGES: "Edit Stages",
      EDIT_USER: "Edit User",
      ELEMENT_DESCRIPTION_MC: "Multiple-choice question (4 choices with at least 1 correct answer)",
      ELEMENT_DESCRIPTION_PORTAL: "Transfer to other stages (4 stages max)",
      ELEMENT_DESCRIPTION_TAG: "Display information (text, voice or image)",
      ELEMENT_DESCRIPTION_TELEPORT: "Navigate from one stage to another",
      ELEMENT_DESCRIPTION_TREASURE: "Hidden text to be sought by students",
      ELEMENT_DESCRIPTION_VOICE_ANSWER: "Record audio to answer questions",
      ELEMENT_POSITION: "Element Position",
      ELEMENT_TYPE: "Element Type",
      ELEMENT_TYPE_MC: "MC",
      ELEMENT_TYPE_PORTAL: "Portal",
      ELEMENT_TYPE_TAG: "Tag",
      ELEMENT_TYPE_TELEPORT: "Teleport",
      ELEMENT_TYPE_TREASURE: "Treasure",
      ELEMENT_TYPE_VOICE_ANSWER: "Voice Answer",
      EMAIL: "Email",
      EMAIL_INCORRECT_REMINDER: "Incorrect Email format",
      EMPTY_CONTENT_REMINDER: "EMPTY_CONTENT_REMINDER",
      EMPTY_HOTSPOT_REMINDER: "EMPTY_HOTSPOT_REMINDER",
      EMPTY_STAGE: "There is no stage content to show.",
      EMPTY_SUBMISSION_REMINDER: "There is no submission in this VITALS.",
      ENABLED: "Enabled",
      ENTER_NEXT_STAGE: "Enter Next Stage Automatically",
      EVERYTHING: "Everything",
      EXPLORE: "Explore",
      EXPORT_ANSWER: "Export Answers",
      FAST: "Optimize Speed",
      FILEPICKER_MESSAGE: "Drag and drop file here, or click to select file",
      FILL_IN_MIND_MAP: "FILL_IN_MIND_MAP",
      FILL_IN_MIND_MAP_DESCRIPTION: "FILL_IN_MIND_MAP_DESCRIPTION",
      FILL_IN_THE_BLANK: "FILL_IN_THE_BLANK",
      FILL_IN_THE_BLANK_DESCRIPTION: "FILL_IN_THE_BLANK_DESCRIPTION",
      FINISH: "Finish",
      FLAT_VIEW: "Flat View",
      HOTSPOT_INVISIBLE: "HOTSPOT_INVISIBLE",
      HOTSPOT_LIST: "Hotspot List",
      HOTSPOT_VISIBILITY: "HOTSPOT_VISIBILITY",
      HOTSPOT_VISIBLE: "HOTSPOT_VISIBLE",
      IMAGE: "Image",
      IMAGE_SEARCH: "IMAGE_SEARCH",
      IMAGE_SIZE: "Image Size",
      INPUT_KEYWORD: "INPUT_KEYWORD",
      KLA_FULL: "Key Learning Area",
      KLA_SHORT: "KLA",
      LARGE: "Large",
      LANGUAGE: "Language",
      LAST_LOGIN_TIME: "Last Login Time",
      LATITUDE: "Latitude",
      LINK: "Link",
      LINK_OTHER_MIND_MAP_BOX: "LINK_OTHER_MIND_MAP_BOX",
      LOCALE_COVER_BLANK_REMINDER: "Please upload a cover image.",
      LOCALE_CREATE_NONE: "No VITALS has been created.",
      LOCALE_INVALID_REMINDER: "VITALS is invalid",
      LOCALE_KLA_BLANK_REMINDER: "Please choose a key learning area.",
      LOCALE_MAP_BLANK_REMINDER: "LOCALE_MAP_BLANK_REMINDER",
      LOCALE_MAP_MAX_SIZE_REMINDER: "LOCALE_MAP_MAX_SIZE_REMINDER",
      LOCALE_MAP_MIN_SIZE_REMINDER: "LOCALE_MAP_MIN_SIZE_REMINDER",
      LOCALE_NAME_BLANK_REMINDER: "Name cannot be blank.",
      LOCALE_SEARCH_RESULT_NONE: "Your search did not match any VITALS.",
      LOCALE_SEARCH_TEXT_PLACEHOLDER: "keyword or school name",
      LOCALE_SUBJECT_BLANK_REMINDER: "LOCALE_SUBJECT_BLANK_REMINDER",
      LOCATE_ELEMENT: "Locate Element",
      LOCATION: "Location",
      LOGOUT: "Logout",
      LONGITUDE: "Longitude",
      MANUAL_START: "Manual start",
      MANUAL_START_YES_MESSAGE: "Start only when the “play” button is clicked.",
      MANUAL_START_NO_MESSAGE: "Start at once when user enters the VITALS.",
      MAP_SIZE: "Map Size (W*H)",
      MC_OF_PICTURES: "MC_OF_PICTURES",
      MC_OF_PICTURES_DESCRIPTION: "MC_OF_PICTURES_DESCRIPTION",
      MC_OF_PICTURES_MULTI: "MC_OF_PICTURES_MULTI",
      MC_OF_PICTURES_MULTI_DESCRIPTION: "MC_OF_PICTURES_MULTI_DESCRIPTION",
      MC_OF_TEXTS: "MC_OF_TEXTS",
      MC_OF_TEXTS_DESCRIPTION: "MC_OF_TEXTS_DESCRIPTION",
      MC_OF_TEXTS_MULTI: "MC_OF_TEXTS_MULTI",
      MC_OF_TEXTS_MULTI_DESCRIPTION: "MC_OF_TEXTS_MULTI_DESCRIPTION",
      MEDIA_TYPE: "Media Type",
      MEDIA_TYPE_WARNING: "Once the media type is selected, it cannot be changed later on.",
      MIND_MAP_BOX: "MIND_MAP_BOX",
      MIND_MAP_FILL_IN_BOX: "MIND_MAP_FILL_IN_BOX",
      MIND_MAP_LABLE_BOX: "MIND_MAP_LABLE_BOX",
      MINUTE_S: "minute(s)",
      MOVE_DOWN: "Move Down",
      MOVE_UP: "Move Up",
      MOVIECLIP: "MOVIECLIP",
      MOVIECLIP_DESCRIPTION: "MOVIECLIP_DESCRIPTION",
      MY_SCHOOL: "My School",
      NAME: "Name",
      NEW_HOTSPOT: "New Hotspot",
      NEW_VITALS: "New VITALS",
      NEW_PASSWORD: "New Password",
      NEW_STAGE: "New Stage",
      NEW_STAGE_ELEMENT: "New Stage Element",
      NEXT: "Next",
      NEXT_PAGE: "Next Page",
      NO: "No",
      NO_ANSWER: "No Answer",
      NONE: "None",
      NOT_POSITIONED: "Unpositioned",
      NO_CONTENT: "Empty",
      NORMAL: "Normal",
      NUMBER_OF_ATTEMPT_S: "Number of attempt(s)",
      OK: "OK",
      OLD_PASSWORD: "Old Password",
      OLD_PASSWORD_NOT_CORRECT: "Your old password is not correct",
      ORIGINAL: "Optimize Quality",
      OVERVIEW: "Overview",
      PAGE: "Page",
      PANORAMA_FORMAT: "Panorama Format",
      PASSWORD_REQUIREMENT_0: "Re-entered password incorrect",
      PASSWORD_REQUIREMENT_1: "Illegal characters, only letter and number allowed",
      PASSWORD_REQUIREMENT_2: "Password should contain both letters and digits",
      PASSWORD_REQUIREMENT_3: "Password should be longer than 6 characters",
      PASSWORD_REQUIREMENT_4: "Password should be shorter than 30 characters",
      PASSWORD_REQUIREMENT_5: "Password cannot be blank",
      PASSWORD_UPDATED: "Password updated",
      PAUSE: "Pause",
      PAUSE_VIDEO: "Pause VITALS",
      PHOTO_360: "360 Photo",
      PLAY: "Play",
      PLEASE_SELECT: "Please Select",
      PREPARING: "Preparing",
      PREVIOUS_PAGE: "Previous Page",
      PORTAL_DESCRIPTION: "Tell the user something about these portals",
      POSITION: "Position",
      POSITIONTED: "Positioned",
      PRIVATE: "Private",
      PROFILE: "Profile",
      PROGRESS: "Progress",
      PUBLIC: "Public",
      PUBLISH: "Publish",
      QR_CODE: "QR Code",
      QUALITY: "Quality",
      QUESTION: "Question",
      QUESTION_DESCRIPTION: "QUESTION_DESCRIPTION",
      RADIUS: "Radius",
      RE_ENTER_NEW_PASSWORD: "Confirm New Password",
      RE_UPLOAD: "Re-Upload",
      READY: "Ready",
      REFRESH: "Refresh",
      REPORT_BUG: "Report Bug",
      REPORT_BUG_REMINDER: "REPORT_BUG_REMINDER",
      RETRIEVE_ANSWERS: "Retrieve Answers",
      ROW: "Row",
      SAFE_IMAGE_SEARCH: "Safe Image Search",
      SAVE: "Save",
      SCHOOL: "School",
      SCHOOL_LIST: "School List",
      SCHOOL_NAME: "School Name",
      SEARCH: "Search",
      SEARCH_PLACE: "Search for a place",
      SECOND_S: "second(s)",
      SECONDS: "seconds",
      SELECT: "Select",
      SELECT_IMAGE: "Select image",
      SELECT_STAGE: "Select Stage",
      SET_POSITION: "SET_POSITION",
      SETTINGS: "Settings",
      SHARABLE: "Sharable",
      SHOW_ALL_ATTEMPTS: "Show all attempts",
      SHOW_IMAGE: "Show Image",
      SHOW_STATISTICS: "Show Statistics",
      SIMPLE_DESCRIPTION: "SIMPLE_DESCRIPTION",
      SIMPLE_DESCRIPTION_DESCRIPTION: "SIMPLE_DESCRIPTION_DESCRIPTION",
      SORT: "Sort",
      SORT_BY: "Sort By",
      SORT_CREATE_DATE_ASC: "Created (Earliest)",
      SORT_CREATE_DATE_DESC: "Created (Latest)",
      SORT_MODIFY_DATE_ASC: "Modified (Earliest)",
      SORT_MODIFY_DATE_DESC: "Modified (Latest)",
      SORT_NAME_ASC: "Name (A-Z)",
      SORT_DOWNLOAD_COUNT_ASC: "Least Downloaded",
      SORT_DOWNLOAD_COUNT_DESC: "Most Downloaded",
      STAGE_SETTINGS: "Stage Settings",
      STATUS: "Status",
      STORAGE: "Storage",
      STORAGE_MANAGEMENT: "Storage Management",
      STUDENT_ANSWER: "Studen Answer",
      SUBJECT: "Subject",
      SUBMISSION_DATE: "Submission Date",
      SUBMISSION_S: "Submission(s)",
      SUBMIT: "Submit",
      SUBMITTED: "submitted",
      SUPPORTED_FILE_TYPE: "Supported File Type",
      SURROUND_SOUND: "Surround Sound",
      SWITCH_BACK_TO_CLASSIC_UI: "Classic UI",
      SWITCH_TO_LIST: "Switch To List",
      SWITCH_TO_MAP: "Swich To Map",
      TABLE_AND_CELL: "TABLE_AND_CELL",
      TABLE_AND_CELL_DESCRIPTION: "TABLE_AND_CELL_DESCRIPTION",
      TAG_TEXT: "Tag Description",
      TAKE_PHOTO: "TAKE_PHOTO",
      TAKE_PHOTO_DESCRIPTION: "TAKE_PHOTO_DESCRIPTION",
      TAKE_RECORD: "TAKE_RECORD",
      TAKE_RECORD_DESCRIPTION: "TAKE_RECORD_DESCRIPTION",
      TARGET_USER: "Target User",
      TELEPORT: "Teleport",
      TIME: "Time",
      TITLE: "Title",
      TOTAL: "Total",
      UNSPECIFIED_SUBJECT: "Unspecified Subject",
      UNSAVED_CHANGES: "UNSAVED_CHANGES",
      UNSAVED_REMINDER: "UNSAVED_REMINDER",
      UNUSED_FILES: "Unused Files",
      UPDATE: "Update",
      UPDATE_FAILED: "Update Failed",
      UPDATE_PASSWORD: "Update Password",
      UPDATE_PROFILE: "Update Profile",
      UPDATE_TIME: "Update Time",
      UPDATED: "Updated",
      UPLOAD: "Upload",
      UPLOAD_COMPLETE: "Upload Completed",
      UPLOAD_FAILED: "Upload Failed",
      UPLOAD_FILE_SIZE_REMINDER: "File size must be less than",
      UPLOAD_FILE_TYPE_REMINDER: "File type not allowed",
      UPLOAD_FILE: "Upload file",
      UPLOAD_LOCAL_FILE: "Upload local file",
      UPLOAD_SCREENSHOT: "Upload screenshot",
      UPLOADED: "Uploaded",
      UPLOADING: "Uploading",
      USER_INFORMATION: "User Information",
      USER_LIST: "User List",
      USERS_CHOICE: "[User's choice]",
      USERNAME: "Username",
      VIDEO_360: "360 Video",
      VIEW_360: "360 View",
      VIEW_BY_SCHOOL: "View by School",
      VIEW_BY_USER: "View by User",
      VIEW_EDIT_DETAILS: "View/Edit Details",
      VIEW_PRIVATE_VITALS: "View Private VITALS",
      VIEW_PUBLIC_VITALS: "View Public VITALS",
      VISIBILITY: "Visibility",
      VITALS_NAME: "VITALS Name",
      VITALS_SHARABLE_MESSAGE: "VITALS can be accessed by your school only",
      VITALS_SIZE: "VITALS Size",
      VITALS_VISIBLE_MESSAGE: "VITALS is visible in the app",
      VITALS_WILL_VISIBLE_MESSAGE: "VITALS will be visible in the app",
      VITALS_INVISIBLE_MESSAGE: "VITALS is invisible in the app",
      VOICE: "Voice",
      VOICE_OVER: "VOICE_OVER",
      VOICE_OVER_DESCRIPTION: "VOICE_OVER_DESCRIPTION",
      YES: "Yes",
      ZOOM: "Zoom",
      ZOOM_IN: "Zoom In",
      ZOOM_OUT: "Zoom Out",
      ACCOUNT_DISABLING_INFO_TITLE: "License Agreement Notice",
      ACCOUNT_DISABLING_CONTENT_LV1: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_DISABLING_CONTENT_LV2: 'This account has been deactivated due to the license agreement mandated by The Chinese University of Hong Kong; please send an email to "clst@fed.cuhk.edu.hk" for the license renewal application.',
      ACCOUNT_SUBSCRIPTION_NOTICE: "Account Subscription Notice",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE: "Account subscription ends in ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST: " days. Account expires after GMT+8 ",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR: "Days until Subscription Expiry: ",
      ACCOUNT_SUBSCRIPTION_INACTIVE: "There is no active subscription plan currently.",
      ACCOUNT_SUBSCRIPTION_PERIOD: "Subscription Period(GMT+8):",
      CUSTOMIZE: "Customize",
      CUSTOM_NAME: "Custom Name",
      VISIBILITY_DURATION: "Visibility Duration (seconds)",
      RETRIEVE_HEATMAP: "Retrieve Heatmap",
      EMPTY_SESSION_REMINDER: "There is no session created in this VITALS.",
      SESSION_LIST: "Session List",
      DATE_LIST: "Date List",
      PROCESS: "Process",
      HEATMAP_RADIUS: "Brush Radius",
      HEATMAP_RESOLUTION: "Resolution",
      HEATMAP_ALPHA: "Transparency",
      HEATMAP_ANIMATION_MODE: "Viewing Mode",
      HEATMAP_ANIMATION_MODE_STANDARD: "Standard Mode",
      HEATMAP_ANIMATION_MODE_FILLING_MODE: "Filling Mode",
      DOWNLOAD: "Download",
      RESET_USER_PASSWORD: "Reset User Password",
      RESET_PASSWORD: "Reset",
      NAME_SHOWN_ON_VITALS: "Name shown on VITALS",
      CAN_BE_USED_AS_LOGIN_NAME: "Can be used as login name",
      YOUR_ORIGINAL_PASSWORD: "Your original password",
      REPORT_BUG_MESSAGE: "Submit feedback or report bug via Google Form?",
      MANUAL_STAGE_CHANGE_MESSAGE: "If set to NO, be sure to create a portal",
      FOR_ADVANCED_USERS: "For advanced users",
      SELECT_KLA: "Select KLA",
      CROSS_KLA: "Cross KLA",
      CHINESE_LANGUAGE: "Chinese Language",
      ENGLISH_LANGUAGE: "English Language",
      MATHEMATICS: "Mathematics",
      SCIENCE: "Science",
      TECHNOLOGY: "Technology",
      P_S_H_E: "P.S.H.E.",
      ARTS: "Arts",
      P_E: "P.E.",
      KLA: "KLA",
    },
    tc:{
      ACCEPT: "接受",
      ACCOUNT_SETTINGS: "帳戶設定",
      ADD: "新增",
      ADD_CONTENT: "新增內容",
      ADD_MIND_MAP_FILL_IN_BOX: "新增填充方塊",
      ADD_MIND_MAP_LABLE_BOX: "新增描述方塊",
      ADMIN_TASK: "管理員職務",
      ALL_SCHOOLS: "所有學校",
      ALL_USERS: "所有用戶",
      ALWAYS: "總是",
      ANSWER_SIZE: "答案大小",
      ASPECT_RATIO: "比例",
      ATTACHMENT: "附件",
      AUTHOR: "作者",
      AUTOPLAY_SOUND: "自動播放聲音",
      BACK: "上一步",
      CANCEL: "取消",
      CATEGORY: "分類",
      CATEGORY_CREATION: "創作",
      CATEGORY_EXPERIENCE: "體驗",
      CATEGORY_EXPERIMENT: "實驗",
      CATEGORY_EXPLORATION: "探究",
      CATEGORY_NONE: "沒分類",
      CATEGORY_KNOWLEDGE: "知識",
      CHANGE: "更改",
      CHANGE_PASSWORD: "更改密碼",
      CHOICE: "選擇",
      CLEAR: "清除",
      CLEAN_UP_ALL_VITALS: "清理所有VITALS",
      CLEAN_UP_HIDDEN_VITALS: "清理隱藏的VITALS",
      CLEAN_UP_UNUSED_FILES: "清理未使用的文件",
      CLOSE: "關閉",
      COLOR: "顏色",
      COLUMN: "欄",
      COMPARE_ANSWERS: "比較答案",
      CONFIRM_PUBLISH_MESSAGE: "確認發布？",
      CONTENT: "內容",
      CONTENT_NAME: "內容名稱",
      CONTENT_PHOTO_FILE_INSTRUCTION: "-如需要多張圖片進行描述，可創建另一個「圖文描述」\n-圖片不是「必須」但建議使用，增加學習動機\n-每個「圖文描述」文字上限為二千字",
      CONTENT_TYPE: "內容種類",
      CONTINUE_EDITING: "繼續編輯",
      CORRECT: "正確",
      CORRECT_ANSWER: "正確答案",
      COVER_IMAGE: "封面圖片",
      CREATE: "建立",
      CREATE_FAILED: "創建失敗",
      CREATE_SCHOOL: "建立學校",
      CREATE_USER: "建立用戶",
      CREATED: "已建立",
      DARK_MODE: "深色模式",
      DATE_INVALID_REMINDER: "日期無效",
      DECLINE: "拒絕",
      DEFAULT: "默認",
      DELETE: "刪除",
      DELETE_CONTENT: "刪除內容",
      DELETE_FAILED: "刪除失敗",
      DELETE_FILE: "刪除檔案",
      DELETE_HOTSPOT: "刪除熱點",
      DELETE_LOCALE: "刪除考察",
      DELETE_MIND_MAP_BOX: "刪除方塊",
      DELETE_MIND_MAP_LINK: "移除方塊連結",
      DELETE_REMINDER: "你確定刪除？這動作不能復原",
      DELETE_STAGE: "刪除STAGE",
      DELETE_VITALS: "刪除VITALS",
      DELETED: "已刪除",
      DEPLOYMENT: "DEPLOYMENT",
      DESCRIPTION: "描述",
      DESCRIPTION_AUDIO: "聲音描述",
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER: "填充之後的文字",
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: "填充之前的文字",
      DESCRIPTION_IMAGE: "描述圖片",
      DESCRIPTION_QUESTION: "問題(可用HTML語法)",
      DESCRIPTION_TAKE_PHOTO: "拍攝題描述",
      DESCRIPTION_TAKE_RECORD: "錄音指示",
      DESCRIPTION_TEXT: "文字描述(可用HTML語法)",
      DESCRIPTION_VIDEO: "描述視頻",
      DESTINATION: "目的地",
      DETAILS: "細節",
      DIFFICULTY: "難度",
      DISCARD: "放棄",
      DISCARD_CHANGES: "放棄更改",
      DISPLAY_NAME: "顯示名稱",
      DISPLAY_NAME_BLANK_REMINDER: "顯示名稱不能為空白",
      DONE: "完成",
      DONE_EDITING: "完成編輯",
      DURATION: "時長",
      EDIT: "編輯",
      EDIT_CONTENT: "編輯內容",
      EDIT_ELEMENT: "編輯元件",
      EDIT_STAGE: "編輯STAGE",
      EDIT_STAGES: "編輯STAGES",
      EDIT_USER: "編輯用戶",
      ELEMENT_DESCRIPTION_MC: "多選題（4個選項至少1個正確答案）",
      ELEMENT_DESCRIPTION_PORTAL: "轉移到其他STAGE（最多4個STAGES）",
      ELEMENT_DESCRIPTION_TAG: "顯示信息（文本、語音或圖像）",
      ELEMENT_DESCRIPTION_TELEPORT: "從一個階段跳轉到另一個STAGE",
      ELEMENT_DESCRIPTION_TREASURE: "學生需尋找隱藏的標籤",
      ELEMENT_DESCRIPTION_VOICE_ANSWER: "錄製音頻回答問題",
      ELEMENT_POSITION: "元件位置",
      ELEMENT_TYPE: "元件類型",
      ELEMENT_TYPE_MC: "多選題",
      ELEMENT_TYPE_PORTAL: "PORTAL",
      ELEMENT_TYPE_TAG: "標籤",
      ELEMENT_TYPE_TELEPORT: "TELEPORT",
      ELEMENT_TYPE_TREASURE: "寶藏",
      ELEMENT_TYPE_VOICE_ANSWER: "語音回答",
      EMAIL: "電郵",
      EMAIL_INCORRECT_REMINDER: "電子郵件格式不正確",
      EMPTY_CONTENT_REMINDER: "未有任何熱點內容，請按加號創建新的內容",
      EMPTY_HOTSPOT_REMINDER: "這考察未有任何熱點，若這是你的考察，請按上方的加號創建新的熱點",
      EMPTY_STAGE: "STAGE沒有內容",
      EMPTY_SUBMISSION_REMINDER: "此VITALS中沒有提交",
      ENABLED: "啟用",
      ENTER_NEXT_STAGE: "自動進入下一STAGE",
      EVERYTHING: "一切",
      EXPLORE: "探索",
      EXPORT_ANSWER: "匯出答案",
      FAST: "優化速度",
      FILEPICKER_MESSAGE: "拖放文件到這裡，或點擊選擇文件",
      FILL_IN_MIND_MAP: "填充概念題",
      FILL_IN_MIND_MAP_DESCRIPTION: "填上概念圖上的空位",
      FILL_IN_THE_BLANK: "填充",
      FILL_IN_THE_BLANK_DESCRIPTION: "填上缺漏的文字",
      FINISH: "完成",
      FLAT_VIEW: "平面視圖",
      HOTSPOT_INVISIBLE: "隱藏顯示",
      HOTSPOT_LIST: "熱點列表",
      HOTSPOT_VISIBILITY: "顯示熱點",
      HOTSPOT_VISIBLE: "正常顯示",
      IMAGE: "圖片",
      IMAGE_SEARCH: "圖片搜尋",
      IMAGE_SIZE: "圖片大小",
      INPUT_KEYWORD: "輸入關鍵字",
      KLA_FULL: "學習領域",
      KLA_SHORT: "學習領域",
      LARGE: "大",
      LANGUAGE: "語言",
      LAST_LOGIN_TIME: "上次登入時間",
      LATITUDE: "緯度",
      LINK: "鏈接",
      LINK_OTHER_MIND_MAP_BOX: "連結其他方塊",
      LOCALE_COVER_BLANK_REMINDER: "請上載一張封面圖片",
      LOCALE_INVALID_REMINDER: "VITALS無效",
      LOCALE_KLA_BLANK_REMINDER: "請選擇一個學習領域",
      LOCALE_MAP_BLANK_REMINDER: "請設定考察範圍",
      LOCALE_MAP_MAX_SIZE_REMINDER: "考察範圍太廣，請把地圖縮放度設為大於15",
      LOCALE_MAP_MIN_SIZE_REMINDER: "考察範圍太窄",
      LOCALE_NAME_BLANK_REMINDER: "名稱不能為空白",
      LOCALE_SEARCH_RESULT_NONE: "未有符合的考察，請嘗試其他查詢方法",
      LOCALE_SEARCH_TEXT_PLACEHOLDER: "關鍵字或學校名稱",
      LOCALE_SUBJECT_BLANK_REMINDER: "請選擇一個學科",
      LOCATE_ELEMENT: "定位元件",
      LOCATION: "地點",
      LOGOUT: "登出",
      LONGITUDE: "經度",
      MANUAL_START: "手動開始",
      MANUAL_START_YES_MESSAGE: "只有當用戶點擊“播放”按鈕時才開始",
      MANUAL_START_NO_MESSAGE: "用戶進入VITALS時立即開始",
      MAP_SIZE: "地圖大小 (長*高)",
      MC_OF_PICTURES: "圖片選擇題",
      MC_OF_PICTURES_DESCRIPTION: "選擇最正確圖片答案",
      MC_OF_PICTURES_MULTI: "圖片多項選擇",
      MC_OF_PICTURES_MULTI_DESCRIPTION: "選擇多個圖片答案",
      MC_OF_TEXTS: "文字選擇題",
      MC_OF_TEXTS_DESCRIPTION: "選擇最正確文字答案",
      MC_OF_TEXTS_MULTI: "文字多項選擇",
      MC_OF_TEXTS_MULTI_DESCRIPTION: "選擇多個文字答案",
      MEDIA_TYPE: "媒體類型",
      MEDIA_TYPE_WARNING: "一旦選擇媒體類型，將不能更改",
      MIND_MAP_BOX: "方塊",
      MIND_MAP_FILL_IN_BOX: "填充方塊",
      MIND_MAP_LABLE_BOX: "描述方塊",
      MINUTE_S: "分鐘",
      MOVE_DOWN: "向上移",
      MOVE_UP: "向下移",
      MOVIECLIP: "短片介紹",
      MOVIECLIP_DESCRIPTION: "mov播放",
      MY_SCHOOL: "我的學校",
      NAME: "名稱",
      NEW_HOTSPOT: "新熱點",
      NEW_VITALS: "新VITALS",
      NEW_PASSWORD: "新密碼",
      NEW_STAGE: "新STAGE",
      NEW_STAGE_ELEMENT: "建立新STAGE元件",
      NEXT: "下一步",
      NEXT_PAGE: "下一頁",
      NO: "否",
      NO_ANSWER: "無答案",
      NONE: "無",
      NOT_POSITIONED : "未選定位置",
      NO_CONTENT: "沒內容",
      NORMAL: "正常",
      NUMBER_OF_ATTEMPT_S: "嘗試次數",
      OK: "好",
      OLD_PASSWORD: "舊密碼",
      OLD_PASSWORD_NOT_CORRECT: "舊密碼不正確",
      ORIGINAL: "優化質素",
      OVERVIEW: "概述",
      PAGE: "頁",
      PANORAMA_FORMAT: "全景格式",
      PASSWORD_REQUIREMENT_0: "重新輸入的密碼不正確",
      PASSWORD_REQUIREMENT_1: "非法字符，只允許字母和數字",
      PASSWORD_REQUIREMENT_2: "密碼應該包含字母和數字",
      PASSWORD_REQUIREMENT_3: "密碼應該長於6個字符",
      PASSWORD_REQUIREMENT_4: "密碼應該短於30個字符",
      PASSWORD_REQUIREMENT_5: "密碼不能為空",
      PASSWORD_UPDATED: "密碼已更新",
      PAUSE: "暫停",
      PAUSE_VIDEO: "暫停VITALS",
      PHOTO_360: "360度照片",
      PLAY: "播放",
      PLEASE_SELECT: "請選擇",
      POSITION: "位置",
      POSITIONTED: "已選定位置",
      PREPARING: "準備中",
      PREVIOUS_PAGE: "上一頁",
      PORTAL_DESCRIPTION: "告訴用戶有關這些PORTAL的一些事情",
      PRIVATE: "私有",
      PROFILE: "個人檔案",
      PROGRESS: "進度",
      PUBLIC: "公開",
      PUBLISH: "發布",
      QR_CODE: "二維碼",
      QUALITY: "質素",
      QUESTION: "問題",
      QUESTION_DESCRIPTION: "文字或圖片短答問題",
      RADIUS: "半徑",
      RE_ENTER_NEW_PASSWORD: "再次輸入新密碼",
      RE_UPLOAD: "重新上傳",
      READY: "就緒",
      REFRESH: "刷新",
      REPORT_BUG: "匯報漏洞",
      REPORT_BUG_REMINDER: "報告錯誤提醒",
      RETRIEVE_ANSWERS: "檢索答案",
      ROW: "行",
      SAFE_IMAGE_SEARCH: "安全搜尋圖片",
      SAVE: "儲存",
      SCHOOL: "學校",
      SCHOOL_LIST: "學校列表",
      SCHOOL_NAME: "學校名稱",
      SEARCH: "搜尋",
      SEARCH_PLACE: "搜索地點",
      SECOND_S: "秒",
      SECONDS: "秒",
      SELECT: "選擇",
      SELECT_IMAGE: "選擇圖片",
      SELECT_STAGE: "選擇STAGE",
      SET_POSITION: "設定位置",
      SETTINGS: "設定",
      SHARABLE: "是否共享",
      SHOW_ALL_ATTEMPTS: "顯示所有嘗試",
      SHOW_IMAGE: "顯示圖片",
      SHOW_STATISTICS: "顯示統計",
      SIMPLE_DESCRIPTION: "圖文描述",
      SIMPLE_DESCRIPTION_DESCRIPTION: "簡單文字及圖片描述",
      SORT: "排序",
      SORT_BY: "排序",
      SORT_CREATE_DATE_ASC: "由最早建立",
      SORT_CREATE_DATE_DESC: "由最近建立",
      SORT_MODIFY_DATE_ASC: "由最早更新",
      SORT_MODIFY_DATE_DESC: "由最近更新",
      SORT_NAME_ASC: "名稱(A-Z)",
      SORT_DOWNLOAD_COUNT_ASC: "最少下載次數",
      SORT_DOWNLOAD_COUNT_DESC: "最多下載次數",
      STAGE_SETTINGS: "STAGE設置",
      STATUS: "狀態",
      STORAGE: "存儲",
      STORAGE_MANAGEMENT: "存儲管理",
      STUDENT_ANSWER: "學生答案",
      SUBJECT: "學科",
      SUBMISSION_DATE: "提交日期",
      SUBMISSION_S: "提交",
      SUBMIT: "提交",
      SUBMITTED: "已提交",
      SUPPORTED_FILE_TYPE: "支持的文件類型",
      SURROUND_SOUND: "環繞音效",
      SWITCH_BACK_TO_CLASSIC_UI: "經典用戶界面",
      SWITCH_TO_LIST: "切換至列表",
      SWITCH_TO_MAP: "切換至地圖",
      TABLE_AND_CELL: "自訂列表",
      TABLE_AND_CELL_DESCRIPTION: "製作列表/統計問題",
      TAG_TEXT: "標籤文本",
      TAKE_PHOTO: "拍照題",
      TAKE_PHOTO_DESCRIPTION: "要求拍攝或繪畫",
      TAKE_RECORD: "錄音或訪問",
      TAKE_RECORD_DESCRIPTION: "要求學生錄音",
      TARGET_USER: "目標用戶",
      TELEPORT: "TELEPORT",
      TIME: "時間",
      TITLE: "標題",
      TOTAL: "總計",
      UNSPECIFIED_SUBJECT: "沒特定科目",
      UNSAVED_CHANGES: "未保存的更改",
      UNSAVED_REMINDER: "未保存提醒",
      UNUSED_FILES: "未使用的文件",
      UPDATE: "更新",
      UPDATE_FAILED: "更新失敗",
      UPDATE_PASSWORD: "更新密碼",
      UPDATE_PROFILE: "更新個人資料",
      UPDATE_TIME: "更新時間",
      UPDATED: "已更新",
      UPLOAD: "上載",
      UPLOAD_COMPLETE: "上載完成",
      UPLOAD_FAILED: "上載失敗",
      UPLOAD_FILE_SIZE_REMINDER: "檔案大小需少於",
      UPLOAD_FILE_TYPE_REMINDER: "不允許的文件類型",
      UPLOAD_FILE: "上載檔案",
      UPLOAD_LOCAL_FILE: "上載本機檔案",
      UPLOAD_SCREENSHOT: "上載截圖",
      UPLOADED: "已上載",
      UPLOADING: "上載中",
      USER_INFORMATION: "用戶資料",
      USER_LIST: "用戶列表",
      USERS_CHOICE: "[用戶選擇]",
      USERNAME: "用戶名稱",
      VIDEO_360: "360度視頻",
      VIEW_360: "360度查看",
      VIEW_BY_SCHOOL: "按學校查看",
      VIEW_BY_USER: "按用戶查看",
      VIEW_EDIT_DETAILS: "查看/編輯詳情",
      VIEW_PRIVATE_VITALS: "查看私有VITALS",
      VIEW_PUBLIC_VITALS: "查看公開VITALS",
      VISIBILITY: "可見性",
      VITALS_NAME: "VITALS名稱",
      VITALS_SHARABLE_MESSAGE: "VITALS只能由你的學校訪問",
      VITALS_SIZE: "VITALS大小",
      VITALS_VISIBLE_MESSAGE: "VITALS在應用程序中可見",
      VITALS_WILL_VISIBLE_MESSAGE: "VITALS將在應用程序中可見",
      VITALS_INVISIBLE_MESSAGE: "VITALS在應用程序中不可見",
      VOICE: "語音",
      VOICE_OVER: "聲音導航",
      VOICE_OVER_DESCRIPTION: "mp3音效檔播放",
      YES: "是",
      ZOOM: "縮放",
      ZOOM_IN: "放大",
      ZOOM_OUT: "縮小",
      ACCOUNT_DISABLING_INFO_TITLE: "許可協議通知",
      ACCOUNT_DISABLING_CONTENT_LV1: '由於香港中文大學的許可協議規定，此賬戶已被停用；請發送電子郵件至"clst@fed.cuhk.edu.hk"申請許可續期。',
      ACCOUNT_DISABLING_CONTENT_LV2: '由於香港中文大學的許可協議規定，此賬戶已被停用；請發送電子郵件至"clst@fed.cuhk.edu.hk"申請許可續期。',
      ACCOUNT_SUBSCRIPTION_NOTICE: "賬戶訂閱通知",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE: "賬戶訂閱將在",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST: "天後結束。賬戶在GMT+8後到期",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR: "訂閱到期天數：",
      ACCOUNT_SUBSCRIPTION_INACTIVE: "目前沒有活躍的訂閱計劃。",
      ACCOUNT_SUBSCRIPTION_PERIOD: "訂閱期限(GMT+8)：",
      CUSTOMIZE: "自定義",
      CUSTOM_NAME: "自定義名稱",
      VISIBILITY_DURATION: "顯示時長 (秒)",
      RETRIEVE_HEATMAP: "檢索熱圖",
      EMPTY_SESSION_REMINDER: "此VITALS中沒有創建會話。",
      SESSION_LIST: "會話列表",
      DATE_LIST: "日期列表",
      PROCESS: "處理",
      HEATMAP_RADIUS: "筆刷半徑",
      HEATMAP_RESOLUTION: "解像度",
      HEATMAP_ALPHA: "透明度",
      HEATMAP_ANIMATION_MODE: "顯示模式",
      HEATMAP_ANIMATION_MODE_STANDARD: "標準模式",
      HEATMAP_ANIMATION_MODE_FILLING_MODE: "填滿模式",
      DOWNLOAD: "下載",
      RESET_USER_PASSWORD: "重設用戶密碼",
      RESET_PASSWORD: "重設",
      NAME_SHOWN_ON_VITALS: "在VITALS上顯示的名稱",
      CAN_BE_USED_AS_LOGIN_NAME: "可用作登錄名",
      YOUR_ORIGINAL_PASSWORD: "你原本的密碼",
      REPORT_BUG_MESSAGE: "通過Google表單提交反饋或報告錯誤？",
      MANUAL_STAGE_CHANGE_MESSAGE: "如果設定為否，請確保創建一個PORTAL",
      FOR_ADVANCED_USERS: "進階用戶",
      SELECT_KLA: "選擇學習領域",
      CROSS_KLA: "跨學習領域",
      CHINESE_LANGUAGE: "中文",
      ENGLISH_LANGUAGE: "英文",
      MATHEMATICS: "數學",
      SCIENCE: "科學",
      TECHNOLOGY: "科技",
      P_S_H_E: "公民及社會教育",
      ARTS: "藝術",
      P_E: "體育",
      KLA: "學習領域",
    },
    sc:{
      ACCEPT: "接受",
      ACCOUNT_SETTINGS: "帐户设置",
      ADD: "新增",
      ADD_CONTENT: "新增内容",
      ADD_MIND_MAP_FILL_IN_BOX: "新增填充方块",
      ADD_MIND_MAP_LABLE_BOX: "新增描述方块",
      ADMIN_TASK: "管理员职务",
      ALL_SCHOOLS: "所有学校",
      ALL_USERS: "所有用户",
      ALWAYS: "总是",
      ANSWER_SIZE: "答案大小",
      ASPECT_RATIO: "比例",
      ATTACHMENT: "附件",
      AUTHOR: "作者",
      AUTOPLAY_SOUND: "自动播放声音",
      BACK: "上一步",
      CANCEL: "取消",
      CATEGORY: "分类",
      CATEGORY_CREATION: "创作",
      CATEGORY_EXPERIENCE: "体验",
      CATEGORY_EXPERIMENT: "实验",
      CATEGORY_EXPLORATION: "探究",
      CATEGORY_NONE: "没分类",
      CATEGORY_KNOWLEDGE: "知识",
      CHANGE: "更改",
      CHANGE_PASSWORD: "更改密码",
      CHOICE: "选择",
      CLEAR: "清除",
      CLEAN_UP_ALL_VITALS: "清理所有VITALS",
      CLEAN_UP_HIDDEN_VITALS: "清理隐藏的VITALS",
      CLEAN_UP_UNUSED_FILES: "清理未使用的文件",
      CLOSE: "关闭",
      COLOR: "颜色",
      COLUMN: "栏",
      COMPARE_ANSWERS: "比较答案",
      CONFIRM_PUBLISH_MESSAGE: "确认发布？",
      CONTENT: "内容",
      CONTENT_NAME: "内容名称",
      CONTENT_PHOTO_FILE_INSTRUCTION: "-如需要多张图片进行描述，可创建另一个「图文描述」\n-图片不是「必须」但建议使用，增加学习动机\n-每个「图文描述」文字上限为二千字",
      CONTENT_TYPE: "内容种类",
      CONTINUE_EDITING: "继续编辑",
      CORRECT: "正确",
      CORRECT_ANSWER: "正确答案",
      COVER_IMAGE: "封面图片",
      CREATE: "建立",
      CREATE_FAILED: "创建失败",
      CREATE_SCHOOL: "创建学校",
      CREATE_USER: "创建用户",
      CREATED: "已建立",
      DARK_MODE: "深色模式",
      DATE_INVALID_REMINDER: "日期无效",
      DECLINE: "拒绝",
      DEFAULT: "默认",
      DELETE: "删除",
      DELETE_CONTENT: "删除内容",
      DELETE_FAILED: "删除失败",
      DELETE_FILE: "删除文件",
      DELETE_HOTSPOT: "删除热点",
      DELETE_LOCALE: "删除考察",
      DELETE_MIND_MAP_BOX: "删除方块",
      DELETE_MIND_MAP_LINK: "移除方块链接",
      DELETE_REMINDER: "你确定删除？这动作不能复原",
      DELETE_STAGE: "删除STAGE",
      DELETE_VITALS: "删除VITALS",
      DELETED: "已删除",
      DEPLOYMENT: "DEPLOYMENT",
      DESCRIPTION: "描述",
      DESCRIPTION_AUDIO: "声音描述",
      DESCRIPTION_FILL_IN_THE_BLANK_AFTER: "填充之后的文字",
      DESCRIPTION_FILL_IN_THE_BLANK_BEFORE: "填充之前的文字",
      DESCRIPTION_IMAGE: "描述图片",
      DESCRIPTION_QUESTION: "问题(可用HTML语法)",
      DESCRIPTION_TAKE_PHOTO: "拍摄题描述",
      DESCRIPTION_TAKE_RECORD: "录音指示",
      DESCRIPTION_TEXT: "文字描述(可用HTML语法)",
      DESCRIPTION_VIDEO: "描述视频",
      DESTINATION: "目的地",
      DETAILS: "细节",
      DIFFICULTY: "难度",
      DISCARD: "放弃",
      DISCARD_CHANGES: "放弃更改",
      DISPLAY_NAME: "显示名称",
      DISPLAY_NAME_BLANK_REMINDER: "显示名称不能为空白",
      DONE: "完成",
      DONE_EDITING: "完成编辑",
      DURATION: "时长",
      EDIT: "编辑",
      EDIT_CONTENT: "编辑内容",
      EDIT_ELEMENT: "编辑元件",
      EDIT_STAGE: "编辑STAGE",
      EDIT_STAGES: "编辑STAGES",
      EDIT_USER: "编辑用户",
      ELEMENT_DESCRIPTION_MC: "多选题（4个选项至少1个正确答案）",
      ELEMENT_DESCRIPTION_PORTAL: "转移到其他STAGE（最多4个STAGES）",
      ELEMENT_DESCRIPTION_TAG: "显示信息（文本、语音或图像）",
      ELEMENT_DESCRIPTION_TELEPORT: "从一个阶段跳转到另一个STAGE",
      ELEMENT_DESCRIPTION_TREASURE: "学生需寻找隐藏的标签",
      ELEMENT_DESCRIPTION_VOICE_ANSWER: "录制音频回答问题",
      ELEMENT_POSITION: "元件位置",
      ELEMENT_TYPE: "元件类型",
      ELEMENT_TYPE_MC: "多选题",
      ELEMENT_TYPE_PORTAL: "PORTAL",
      ELEMENT_TYPE_TAG: "标签",
      ELEMENT_TYPE_TELEPORT: "TELEPORT",
      ELEMENT_TYPE_TREASURE: "宝藏",
      ELEMENT_TYPE_VOICE_ANSWER: "语音回答",
      EMAIL: "电邮",
      EMAIL_INCORRECT_REMINDER: "电子邮件格式不正确",
      EMPTY_CONTENT_REMINDER: "未有任何热点内容，请按加号创建新的内容",
      EMPTY_HOTSPOT_REMINDER: "这考察未有任何热点，若这是你的考察，请按上方的加号创建新的热点",
      EMPTY_STAGE: "STAGE没有内容",
      EMPTY_SUBMISSION_REMINDER: "此VITALS中没有提交",
      ENABLED: "启用",
      ENTER_NEXT_STAGE: "自动进入下一STAGE",
      EVERYTHING: "一切",
      EXPLORE: "探索",
      EXPORT_ANSWER: "汇出答案",
      FAST: "优化速度",
      FILEPICKER_MESSAGE: "拖放文件到这里，或点击选择文件",
      FILL_IN_MIND_MAP: "填充概念题",
      FILL_IN_MIND_MAP_DESCRIPTION: "填上概念图上的空位",
      FILL_IN_THE_BLANK: "填充",
      FILL_IN_THE_BLANK_DESCRIPTION: "填上缺漏的文字",
      FINISH: "完成",
      FLAT_VIEW: "平面视图",
      HOTSPOT_INVISIBLE: "隐藏显示",
      HOTSPOT_LIST: "热点列表",
      HOTSPOT_VISIBILITY: "显示热点",
      HOTSPOT_VISIBLE: "正常显示",
      IMAGE: "图片",
      IMAGE_SEARCH: "图片搜索",
      IMAGE_SIZE: "图片大小",
      INPUT_KEYWORD: "输入关键字",
      KLA_FULL: "学习领域",
      KLA_SHORT: "学习领域",
      LARGE: "大",
      LANGUAGE: "语言",
      LAST_LOGIN_TIME: "上次登入时间",
      LATITUDE: "纬度",
      LINK: "链接",
      LINK_OTHER_MIND_MAP_BOX: "连接其他方块",
      LOCALE_COVER_BLANK_REMINDER: "请上传一张封面图片",
      LOCALE_INVALID_REMINDER: "VITALS无效",
      LOCALE_KLA_BLANK_REMINDER: "请选择一个学习领域",
      LOCALE_MAP_BLANK_REMINDER: "请设定考察范围",
      LOCALE_MAP_MAX_SIZE_REMINDER: "考察范围太广，请把地图缩放度设为大于15",
      LOCALE_MAP_MIN_SIZE_REMINDER: "考察范围太窄",
      LOCALE_NAME_BLANK_REMINDER: "名称不能为空白",
      LOCALE_SEARCH_RESULT_NONE: "未有符合的考察，请尝试其他查询方法",
      LOCALE_SEARCH_TEXT_PLACEHOLDER: "关键字或学校名称",
      LOCALE_SUBJECT_BLANK_REMINDER: "请选择一个学科",
      LOCATE_ELEMENT: "定位元件",
      LOCATION: "地点",
      LOGOUT: "登出",
      LONGITUDE: "经度",
      MANUAL_START: "手动开始",
      MANUAL_START_YES_MESSAGE: "只有当用户点击“播放”按钮时才开始",
      MANUAL_START_NO_MESSAGE: "用户进入VITALS时立即开始",
      MAP_SIZE: "地图大小 (长*高)",
      MC_OF_PICTURES: "图片选择题",
      MC_OF_PICTURES_DESCRIPTION: "选择最正确图片答案",
      MC_OF_PICTURES_MULTI: "图片多项选择",
      MC_OF_PICTURES_MULTI_DESCRIPTION: "选择多个图片答案",
      MC_OF_TEXTS: "文字选择题",
      MC_OF_TEXTS_DESCRIPTION: "选择最正确文字答案",
      MC_OF_TEXTS_MULTI: "文字多项选择",
      MC_OF_TEXTS_MULTI_DESCRIPTION: "选择多个文字答案",
      MEDIA_TYPE: "媒体类型",
      MEDIA_TYPE_WARNING: "一旦选择媒体类型，将不能更改",
      MIND_MAP_BOX: "方块",
      MIND_MAP_FILL_IN_BOX: "填充方块",
      MIND_MAP_LABLE_BOX: "描述方块",
      MINUTE_S: "分钟",
      MOVE_DOWN: "向上移",
      MOVE_UP: "向下移",
      MOVIECLIP: "短片介绍",
      MOVIECLIP_DESCRIPTION: "mov播放",
      MY_SCHOOL: "我的学校",
      NAME: "名称",
      NEW_HOTSPOT: "新热点",
      NEW_VITALS: "新VITALS",
      NEW_PASSWORD: "新密码",
      NEW_STAGE: "新STAGE",
      NEW_STAGE_ELEMENT: "建立新STAGE元件",
      NEXT: "下一步",
      NEXT_PAGE: "下一页",
      NO: "否",
      NO_ANSWER: "无答案",
      NONE: "无",
      NOT_POSITIONED : "未选定位置",
      NO_CONTENT: "没内容",
      NORMAL: "正常",
      NUMBER_OF_ATTEMPT_S: "尝试次数",
      OK: "好",
      OLD_PASSWORD: "旧密码",
      OLD_PASSWORD_NOT_CORRECT: "旧密码不正确",
      ORIGINAL: "优化质素",
      OVERVIEW: "概述",
      PAGE: "页",
      PANORAMA_FORMAT: "全景格式",
      PASSWORD_REQUIREMENT_0: "重新输入的密码不正确",
      PASSWORD_REQUIREMENT_1: "非法字符，只允许字母和数字",
      PASSWORD_REQUIREMENT_2: "密码应该包含字母和数字",
      PASSWORD_REQUIREMENT_3: "密码应该长于6个字符",
      PASSWORD_REQUIREMENT_4: "密码应该短于30个字符",
      PASSWORD_REQUIREMENT_5: "密码不能为空",
      PASSWORD_UPDATED: "密码已更新",
      PAUSE: "暂停",
      PAUSE_VIDEO: "暂停VITALS",
      PHOTO_360: "360度照片",
      PLAY: "播放",
      PLEASE_SELECT: "请选择",
      POSITION: "位置",
      POSITIONTED: "已选定位置",
      PREPARING: "准备中",
      PREVIOUS_PAGE: "上一页",
      PORTAL_DESCRIPTION: "告诉用户有关这些PORTAL的一些事情",
      PRIVATE: "私有",
      PROFILE: "个人档案",
      PROGRESS: "进度",
      PUBLIC: "公开",
      PUBLISH: "发布",
      QR_CODE: "二维码",
      QUALITY: "质素",
      QUESTION: "问题",
      QUESTION_DESCRIPTION: "文字或图片短答问题",
      RADIUS: "半径",
      RE_ENTER_NEW_PASSWORD: "再次输入新密码",
      RE_UPLOAD: "重新上传",
      READY: "就绪",
      REFRESH: "刷新",
      REPORT_BUG: "报告漏洞",
      REPORT_BUG_REMINDER: "报告错误提醒",
      RETRIEVE_ANSWERS: "检索答案",
      ROW: "行",
      SAFE_IMAGE_SEARCH: "安全搜索图片",
      SAVE: "储存",
      SCHOOL: "学校",
      SCHOOL_LIST: "学校列表",
      SCHOOL_NAME: "学校名称",
      SEARCH: "搜索",
      SEARCH_PLACE: "搜索地点",
      SECOND_S: "秒",
      SECONDS: "秒",
      SELECT: "选择",
      SELECT_IMAGE: "选择图片",
      SELECT_STAGE: "选择STAGE",
      SET_POSITION: "设定位置",
      SETTINGS: "设置",
      SHARABLE: "是否共享",
      SHOW_ALL_ATTEMPTS: "显示所有尝试",
      SHOW_IMAGE: "显示图片",
      SHOW_STATISTICS: "显示统计",
      SIMPLE_DESCRIPTION: "图文描述",
      SIMPLE_DESCRIPTION_DESCRIPTION: "简单文字及图片描述",
      SORT: "排序",
      SORT_BY: "排序",
      SORT_CREATE_DATE_ASC: "由最早建立",
      SORT_CREATE_DATE_DESC: "由最近建立",
      SORT_MODIFY_DATE_ASC: "由最早更新",
      SORT_MODIFY_DATE_DESC: "由最近更新",
      SORT_NAME_ASC: "名称(A-Z)",
      SORT_DOWNLOAD_COUNT_ASC: "最少下载次数",
      SORT_DOWNLOAD_COUNT_DESC: "最多下载次数",
      STAGE_SETTINGS: "STAGE设置",
      STATUS: "状态",
      STORAGE: "存储",
      STORAGE_MANAGEMENT: "存储管理",
      STUDENT_ANSWER: "学生答案",
      SUBJECT: "学科",
      SUBMISSION_DATE: "提交日期",
      SUBMISSION_S: "提交",
      SUBMIT: "提交",
      SUBMITTED: "已提交",
      SUPPORTED_FILE_TYPE: "支持的文件类型",
      SURROUND_SOUND: "环绕音效",
      SWITCH_BACK_TO_CLASSIC_UI: "经典用户界面",
      SWITCH_TO_LIST: "切换至列表",
      SWITCH_TO_MAP: "切换至地图",
      TABLE_AND_CELL: "自订列表",
      TABLE_AND_CELL_DESCRIPTION: "制作列表/统计问题",
      TAG_TEXT: "标签文本",
      TAKE_PHOTO: "拍照题",
      TAKE_PHOTO_DESCRIPTION: "要求拍摄或绘画",
      TAKE_RECORD: "录音或访问",
      TAKE_RECORD_DESCRIPTION: "要求学生录音",
      TARGET_USER: "目标用户",
      TELEPORT: "TELEPORT",
      TIME: "时间",
      TITLE: "标题",
      TOTAL: "总计",
      UNSPECIFIED_SUBJECT: "没特定科目",
      UNSAVED_CHANGES: "未保存的更改",
      UNSAVED_REMINDER: "未保存提醒",
      UNUSED_FILES: "未使用的文件",
      UPDATE: "更新",
      UPDATE_FAILED: "更新失败",
      UPDATE_PASSWORD: "更新密码",
      UPDATE_PROFILE: "更新个人资料",
      UPDATE_TIME: "更新时间",
      UPDATED: "已更新",
      UPLOAD: "上传",
      UPLOAD_COMPLETE: "上传完成",
      UPLOAD_FAILED: "上传失败",
      UPLOAD_FILE_SIZE_REMINDER: "档案大小需少于",
      UPLOAD_FILE_TYPE_REMINDER: "不允许的文件类型",
      UPLOAD_FILE: "上传档案",
      UPLOAD_LOCAL_FILE: "上传本机档案",
      UPLOAD_SCREENSHOT: "上传截图",
      UPLOADED: "已上传",
      UPLOADING: "上传中",
      USER_INFORMATION: "用户资料",
      USER_LIST: "用户列表",
      USERS_CHOICE: "[用户选择]",
      USERNAME: "用户名",
      VIDEO_360: "360度视频",
      VIEW_360: "360度查看",
      VIEW_BY_SCHOOL: "按学校查看",
      VIEW_BY_USER: "按用户查看",
      VIEW_EDIT_DETAILS: "查看/编辑详情",
      VIEW_PRIVATE_VITALS: "查看私有VITALS",
      VIEW_PUBLIC_VITALS: "查看公开VITALS",
      VISIBILITY: "可见性",
      VITALS_NAME: "VITALS名称",
      VITALS_SHARABLE_MESSAGE: "VITALS只能由你的学校访问",
      VITALS_SIZE: "VITALS大小",
      VITALS_VISIBLE_MESSAGE: "VITALS在应用程序中可见",
      VITALS_WILL_VISIBLE_MESSAGE: "VITALS将在应用程序中可见",
      VITALS_INVISIBLE_MESSAGE: "VITALS在应用程序中不可见",
      VOICE: "语音",
      VOICE_OVER: "声音导航",
      VOICE_OVER_DESCRIPTION: "mp3音效档播放",
      YES: "是",
      ZOOM: "缩放",
      ZOOM_IN: "放大",
      ZOOM_OUT: "缩小",
      ACCOUNT_DISABLING_INFO_TITLE: "许可协议通知",
      ACCOUNT_DISABLING_CONTENT_LV1: '由于香港中文大学的许可协议规定，此账户已被停用；请发送电子邮件至"clst@fed.cuhk.edu.hk"申請許可續期。',
      ACCOUNT_DISABLING_CONTENT_LV2: '由于香港中文大学的许可协议规定，此账户已被停用；请发送电子邮件至"clst@fed.cuhk.edu.hk"申請許可續期。',
      ACCOUNT_SUBSCRIPTION_NOTICE: "账户订阅通知",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_PRE: "账户订阅将在",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_POST: "天后结束。账户在GMT+8后到期",
      ACCOUNT_SUBSCRIPTION_EXPIRE_SOON_BAR: "订阅到期天数：",
      ACCOUNT_SUBSCRIPTION_INACTIVE: "目前没有活跃的订阅计划。",
      ACCOUNT_SUBSCRIPTION_PERIOD: "订阅期限(GMT+8)：",
      CUSTOMIZE: "自定义",
      CUSTOM_NAME: "自定义名称",
      VISIBILITY_DURATION: "显示时长 (秒)",
      RETRIEVE_HEATMAP: "检索热图",
      EMPTY_SESSION_REMINDER: "此VITALS中没有创建会话。",
      SESSION_LIST: "会话列表",
      DATE_LIST: "日期列表",
      PROCESS: "处理",
      HEATMAP_RADIUS: "笔刷半径",
      HEATMAP_RESOLUTION: "解像度",
      HEATMAP_ALPHA: "透明度",
      HEATMAP_ANIMATION_MODE: "显示模式",
      HEATMAP_ANIMATION_MODE_STANDARD: "标准模式",
      HEATMAP_ANIMATION_MODE_FILLING_MODE: "填满模式",
      DOWNLOAD: "下载",
      RESET_USER_PASSWORD: "重设用户密码",
      RESET_PASSWORD: "重设",
      NAME_SHOWN_ON_VITALS: "在VITALS上显示的名称",
      CAN_BE_USED_AS_LOGIN_NAME: "可用作登录名",
      YOUR_ORIGINAL_PASSWORD: "你原本的密码",
      REPORT_BUG_MESSAGE: "通过Google表单提交反馈或报告错误？",
      MANUAL_STAGE_CHANGE_MESSAGE: "如果设定为否，请确保创建一个PORTAL",
      FOR_ADVANCED_USERS: "進階用户",
      SELECT_KLA: "选择学习领域",
      CROSS_KLA: "跨学习领域",
      CHINESE_LANGUAGE: "中文",
      ENGLISH_LANGUAGE: "英文",
      MATHEMATICS: "数学",
      SCIENCE: "科学",
      TECHNOLOGY: "科技",
      P_S_H_E: "公民及社会教育",
      ARTS: "艺术",
      P_E: "体育",
      KLA: "学习领域",
    },
  })
}

export default Localization;
